import {AsyncPage, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {Page} from 'Core/models/Page';
import {pipe} from 'fp-ts/lib/pipeable';
import {fold as foldOption, fromNullable} from 'fp-ts/lib/Option';
import {constant} from 'fp-ts/lib/function';
import {PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import * as O from 'fp-ts/lib/Option';
import {InequalityRangeFilter} from 'Core/models/InequalityRange';
import {ClientMessage} from 'GenericTexting/models/ClientMessage';

export enum ClientMessageActionType {
  GET_CLIENT_MESSAGES = 'client/GET_CLIENT_MESSAGES',
  CHANGE_CLIENT_MESSAGES = 'client/CHANGE_CLIENT_MESSAGES',
  CHANGE_CLIENT_MESSAGES_FILTER = 'client/CHANGE_CLIENT_MESSAGES_FILTER',
}

export const DefaultClientFilters: ClientMessageFilters = {
  pageSize: 0,
  clientId: '',
  clientName: '',
  numberOfMessages: O.none,
  numberOfOptInMessages: O.none,
  numberOfPhoneNumbers: O.none,
  ageOfOldestMessageInDays: O.none,
  ageOfNewestMessageInDays: O.none,
};

export type ClientMessageFilters = {
  pageSize?: number;
  clientId: string;
  clientName: string;
  numberOfMessages: InequalityRangeFilter;
  numberOfOptInMessages: InequalityRangeFilter;
  numberOfPhoneNumbers: InequalityRangeFilter;
  ageOfOldestMessageInDays: InequalityRangeFilter;
  ageOfNewestMessageInDays: InequalityRangeFilter;
};

export const searchClientMessages = (pageOption?: Page<ClientMessage>, filter?: ClientMessageFilters) => {
  const payload = pipe(
    fromNullable(pageOption),
    foldOption(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(ClientMessageActionType.GET_CLIENT_MESSAGES, payload);
};

export const changeClientMessages = (messageClientReports: AsyncPage<Page<ClientMessage>>) =>
  createAction(ClientMessageActionType.CHANGE_CLIENT_MESSAGES, messageClientReports);

export const changeClientMessagesFilters = (filters: ClientMessageFilters) =>
  createAction(ClientMessageActionType.CHANGE_CLIENT_MESSAGES_FILTER, {filters});

type ClientMessageState = {
  clientMessagePage: AsyncPage<Page<ClientMessage>>;
  filter: ClientMessageFilters;
};

export const DEFAULT_STATE: ClientMessageState = {
  clientMessagePage: new Empty(),
  filter: DefaultClientFilters,
};

type ClientMessageAction =
  | ReturnType<typeof searchClientMessages>
  | ReturnType<typeof changeClientMessages>
  | ReturnType<typeof changeClientMessagesFilters>;

export default (state: ClientMessageState = DEFAULT_STATE, action: ClientMessageAction): ClientMessageState => {
  switch (action.type) {
    case ClientMessageActionType.CHANGE_CLIENT_MESSAGES:
      return {
        ...state,
        clientMessagePage: action.payload,
      };
    case ClientMessageActionType.CHANGE_CLIENT_MESSAGES_FILTER:
      return {
        ...state,
        filter: action.payload.filters,
      };
    default:
      return state;
  }
};
